"use client";

import { AuthProvider } from "@/contexts/auth-context";
import type { ReactNode } from "react";

export function Providers({
  children,
}: {
  children: ReactNode;
  nonce?: string;
}) {
  return <AuthProvider>{children}</AuthProvider>;
}
